import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-schools',
  standalone: false,
  templateUrl: './admin-schools.component.html',
  styleUrl: './admin-schools.component.css'
})

export class AdminSchoolsComponent implements OnInit {

  schools: any = [];
  authToken = localStorage.getItem('auth');
  isLoading = false;
  selectedBusiness: any;
  currentSkill: any;
  edit_form: FormGroup;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.edit_form = this.fb.group({
      e_fi: ['', [
        Validators.required,
      ]],
      e_en: ['', [
        Validators.required,
      ]],
      e_sv: ['', [
        Validators.required,
      ]],
    });

    this.fetchSchools();
  }

  fetchSchools() {
    //Fetch skills that are not assigned
    this.http.get(environment.ADMIN_UNASSIGNED_SCHOOLS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.schools = res.message;

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

}
